module.exports = __webpack_public_path__ + "img/42.8f56585a.png";